import { render, staticRenderFns } from "./ElementScreenshot.vue?vue&type=template&id=83080f56&"
import script from "./ElementScreenshot.vue?vue&type=script&lang=ts&"
export * from "./ElementScreenshot.vue?vue&type=script&lang=ts&"
import style0 from "./ElementScreenshot.vue?vue&type=style&index=0&id=83080f56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports